import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Off"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-off',
    templateUrl: './icon-cash-off.component.html',
    styleUrls: ['./icon-cash-off.component.scss'],
    standalone: false
})
export class IconCashOffComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
